export enum FixturesFilterTypes {
  HomeCompetitors = "HomeCompetitors",
  AwayCompetitors = "AwayCompetitors",
  HomeParticipants = "HomeParticipants",
  AwayParticipants = "AwayParticipants",
  Venues = "Venues",
  StartDates = "StartDates",
  FixtureTypes = "FixtureTypes",
  FixtureStatuses = "FixtureStatuses",
  Stages = "Stages",
  Pools = "Pools",
  Series = "Series",
  Competitors = "Competitors",
  Participants = "Participants",
  DateRange = "DateRange",
  RoundNumber = "RoundNumber",
}
